import React, { useState, useEffect } from 'react';
import { ReactComponent as MeccaIcon } from '../icon/mecca-icon.svg';
import { ReactComponent as MedinaIcon } from '../icon/medina-icon.svg';

function RevelationIcon({ revelation, className = "w-4 h-4" }) {
  const [isDark, setIsDark] = useState(false);
  
  useEffect(() => {
    // Function to check and update theme
    const checkTheme = () => {
      const darkMode = document.documentElement.classList.contains('dark');
      setIsDark(darkMode);
    };
    
    // Check theme on mount
    checkTheme();
    
    // Create a MutationObserver to watch for class changes on documentElement
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          checkTheme();
        }
      });
    });
    
    // Start observing
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class']
    });
    
    // Cleanup observer on unmount
    return () => observer.disconnect();
  }, []);
  
  const fillColor = isDark ? "#ffffff" : "#000000";
  
  if (revelation?.toLowerCase() === "mecca") {
    return <MeccaIcon className={className} fill={fillColor} />;
  } else if (revelation?.toLowerCase() === "medina") {
    return <MedinaIcon className={className + " w-5 h-5"} fill={fillColor} />;
  }
  
  return null;
}

export default RevelationIcon; 